import { PhoneNumberUtil } from 'google-libphonenumber'

const phoneUtil = PhoneNumberUtil.getInstance()

export const isValidIntlPhone = (value) => {
  if (!value) return false
  if (!value.startsWith('+')) return false
  try {
    const num = phoneUtil.parse(value, 'ZZ')
    return phoneUtil.isValidNumber(num)
  } catch {
    return false
  }
}
